<template>
    <div class="card">
        <div class="card-header text-center">
            {{ title }}
        </div>
        <div class="card-body">
            <ul id="">
                <li v-for="elem in text" :key="elem.id">
                   <a href="#infLetters" @click="gotoInfLetters(elem, questionToRecommendationId, infLetters)"> {{ elem }} </a>
                </li>
            </ul>
            <a href="/Fragencodes.pdf" class="pdf-link" target="_blank">Fragencodes ansehen</a>
        </div>
    </div>
</template>

<style scoped>
.pdf-link {
    color: inherit; /* Keeps default color */
    text-decoration: none; /* No underline by default */
}

.pdf-link:hover {
    color: blue; /* Changes to blue on hover */
    text-decoration: underline; /* Adds underline on hover */
}
</style>



<script>
export default {
    name: "Card",
    props: ["title", "text", "infLetters", "questionToRecommendationId"],
    methods:{
        gotoInfLetters(element, questionToRecommendationId, infLetters){
            const arr = element.split(":");
            let questionRec = questionToRecommendationId[arr[0]];
            if (questionRec !== undefined) {
                outer: for (let i = 0; i <infLetters.length; i++) {
                    for (let j = 0; j < questionRec.length; j++) {
                        for (let z = 0; z < infLetters[i].pivot["RecommendationId"].length; z++) {
                            if (typeof infLetters[i].pivot["RecommendationId"] === "string") {
                                if (infLetters[i].pivot["RecommendationId"] === questionRec[j]) {
                                    $('#collapseCard' + i).collapse('show');
                                    continue outer;
                                }
                                break;
                            }
                            if (infLetters[i].pivot["RecommendationId"][z] === questionRec[j]) {
                                $('#collapseCard' + i).collapse('show');
                                continue outer;
                            }
                        }
                    }
                    $('#collapseCard' + i).collapse('hide');
                }
            }
            return true;
        },
        }
};
</script>
